import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigCoverGoUat from "./appConfigCoverGoUat.js"
import appConfigCoverGoProd from "./appConfigCoverGoProd"
import { COVERGO_ASIA_PROD, COVERGO_SAAS_DEV } from "../consts.js"

export const dlvn = {
					// DEV
					"dlvn-dev-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_DEV },

					// UAT
					"dlvn-uat-studio.quote.hk": { appConfig: appConfigCoverGoUat, envConfig: COVERGO_ASIA_PROD },

					// Prod
					"dlvn-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_ASIA_PROD }
				}
